import FriendsList from '@/components/FriendsList';
import FriendsRecommendation from '@/components/FriendsRecommendation';
import PlayerSearch from '@/components/PlayerSearch';
import { api } from '@/utils/api';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Friends() {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [friends, setFriends] = useState([]);

  document.title = t('friends')

  useEffect(() => {
    const fetchFriends = async () => {
      try {
        const { data } = await api.get('/friendships/list');
        setFriends(data.friends);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching friends:', error);
      }
    };

    fetchFriends();
  }, []);

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold">{t('loading')}</h2>
        </div>
      </div>
    );
  }


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar className='bg-card'>
          <IonButtons slot="start" className='md:hidden'>
            <IonBackButton text={t('back')} defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>{t('friends')}</IonTitle>
          <IonButtons slot="end">
            <PlayerSearch />
          </IonButtons>
        </IonToolbar>
      </IonHeader >
      <IonContent>
        <FriendsRecommendation />
        <FriendsList friends={friends} />
      </IonContent>
    </IonPage >
  );
}
